import { PlusIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { Link } from "react-router-dom";

export function QuickActionList({
    title = "Quick actions",
    children,
}: {
    title?: string;
    children: React.ReactNode;
}) {
    return (
        <div className="flex flex-col gap-4">
            <p className="lozenge">{title}</p>
            <ul className="-mx-4">{children}</ul>
        </div>
    );
}

export function QuickActionItem({
    href,
    label,
    isLoading,
}: {
    href?: string | null;
    label: string;
    isLoading: boolean;
}) {
    return (
        <li className="card w-full cursor-pointer">
            {href && (
                <Link to={href} className="flex items-center gap-2">
                    <PlusIcon className="stroke-default size-4" />
                    <span>{label}</span>
                </Link>
            )}

            {isLoading && (
                <div
                    className={clsx(
                        "bg-selected h-5 w-[300px]",
                        "animate-pulse rounded",
                    )}
                />
            )}
        </li>
    );
}
